import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportPartnerRatingByPartnerUgoExcel } from '../api';

export function useExportPartnerRatingByPartnerUgoExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportPartnerRatingByPartnerUgoExcelReport = async (partnerGuid: string, config?: AxiosRequestConfig) => {
    setLoading(true);

    try {
      downloadFile(
        await exportPartnerRatingByPartnerUgoExcel(partnerGuid, config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по партнеру УГО.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportPartnerRatingByPartnerUgoExcelReport };
}
